module.exports = __webpack_public_path__ + "static/media/partner-logo4.931a2e9b.png";